import NotificationSender from "../../components/pushNotificationComponent/notificationSender";
import "./notificationPage.css";
import { Card, Tag,  Image, List, Space, Typography } from "antd";
import confirmationIamge from "./confirmationImage.svg";
import { useEffect, useState } from "react";
import {
  QueryClient,
  QueryClientProvider
} from "@tanstack/react-query";
import { listNotification } from "../../services/pushNotifications";

// Interface tipando as notificações
interface Notification {
  title: string;
  body: string;
  success_count: number;
  failed_count: number;
  created_at: string;
}
const { Title, Text } = Typography;

export default function NotificationPage() {
  const [load, setLoad] = useState(true);
  const [notificationsSended, setNotificationsSended] = useState<Notification[]>([]);
  const queryClient = new QueryClient();

  useEffect(() => {
    const elementToAnimate = document.querySelector(".image_notification");
    const formToAnimate = document.querySelector(".form_notification");
    elementToAnimate?.classList.remove("image_notification");
    elementToAnimate?.classList.add("image_animation");
    formToAnimate?.classList.remove("form_notification");
    formToAnimate?.classList.add("form_animation");
  }, []);
  function getNotfications() {
    setLoad(true);
    listNotification().then((response) => {
      setNotificationsSended(response);
      setLoad(false);
      console.log("Notificações recebidas:", response);
    }
    ).catch((error) => {
      console.error("Erro ao buscar notificações:", error);
      setLoad(false);
    }
    );
  }
  useEffect(() => {
    getNotfications()
  },[])
  return (
    <div className="body_main">
      <div>
        <div className="notification_container">
          <div className="notification_details">
            <h3>
              <strong>Pagina de Notificação</strong>
            </h3>
            <p>
              <strong>Envia notificação aos clientes!</strong>
            </p>
            <Image
              width={300}
              src={confirmationIamge}
              preview={false}
              className="image_notification"
            />
          </div>

          <div className="form_notification" style={{ flex: 1.5 }}>
            <QueryClientProvider client={queryClient}>
              <NotificationSender reload={() =>getNotfications()} />
            </QueryClientProvider>
          </div>

          <div className="notification_details_all" style={{ flex: 3 }}>
            <div className="notification_all_box" style={{ width: "90%" }}>
              <List
                header={
                  <div
                    className="notification_details_title"
                    style={{ fontWeight: "bold" }}
                  >
                    Notificações enviadas
                  </div>
                }
                bordered={true}
                itemLayout="horizontal"
                dataSource={notificationsSended}
                loading={load}
                renderItem={(item) => (
                  <Card
                    hoverable
                    className="products_edit"
                    style={{ marginBottom: 16, borderRadius: 10, margin: 16 }}
                  >
                    <Space direction="vertical" size="small" style={{ width: "100%" }}>
                      <Title level={4} style={{ marginBottom: 0 }}>
                        {item.title}
                      </Title>
              
                      <Text type="secondary">{item.body}</Text>
              
                      <Space size="middle" style={{ marginTop: 8 }}>
                        <Tag color="green">
                          Enviadas: {item.success_count}
                        </Tag>
                        <Tag  color="red">
                          Falhas: {item.failed_count}
                        </Tag>
                        <Tag  color="blue">
                          {new Date(item.created_at).toLocaleString("pt-BR")}
                        </Tag>
                      </Space>
                    </Space>
                  </Card>
                )}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
